import { createApi } from '@reduxjs/toolkit/query/react';

import { ENVS } from '@/shared/consts';

import { teachbaseBaseQueryWithReauth } from '../queries/teachbaseBaseQuery';

export const teachbaseService = createApi({
  baseQuery: teachbaseBaseQueryWithReauth({ baseUrl: ENVS.LMS_API_BASEURL }),
  tagTypes: [],
  endpoints: () => ({}),
  reducerPath: 'teachbaseApiSlice',
});
